module.exports = __webpack_public_path__ + "static/media/terraspeak-5.740a5c76.jpg";